import {
  Component,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ContactService } from "src/app/services/contact.service";

@Component({
  selector: "app-contact-form",
  templateUrl: "./contact-form.component.html",
  styleUrls: ["./contact-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ContactFormComponent {
  @Input() item;
  public form: FormGroup;

  public nameForm: FormControl;
  public lastnameForm: FormControl;
  public telephoneForm: FormControl;
  public emailForm: FormControl;
  public productsForm: FormControl;
  public locationForm: FormControl;
  public captchaForm: FormControl;
  // public companyForm: FormControl;
  // public enquiryForm: FormControl;

  constructor(
    protected formBuilder: FormBuilder,
    protected contactService: ContactService // protected loadingService: LoadingService, // protected messagesService: MessagesService
  ) {
    this.nameForm = this.formBuilder.control("", Validators.required);
    this.lastnameForm = this.formBuilder.control("", Validators.required);
    this.telephoneForm = this.formBuilder.control("", Validators.required);
    this.emailForm = this.formBuilder.control("", [
      Validators.required,
      Validators.email,
    ]);
    this.productsForm = this.formBuilder.control(null, [Validators.required]);
    this.locationForm = this.formBuilder.control("", Validators.required);
    this.captchaForm = this.formBuilder.control("", Validators.required);
    // this.companyForm = this.formBuilder.control("");
    //this.enquiryForm = this.formBuilder.control("", Validators.required);

    this.form = this.formBuilder.group({
      name: this.nameForm,
      lastname: this.lastnameForm,
      //company: this.companyForm,
      //enquiry: this.enquiryForm,
      email: this.emailForm,
      telephone: this.telephoneForm,
      products: this.productsForm,
      location: this.locationForm,
      captcha: this.captchaForm,
    });
  }

  clearForm() {
    this.form.reset();
  }

  public onSubmit(data) {
    const formData = new FormData();
    //	"03AGdBq26ImDYuqgjK77wX0VJUOGEcfnB3FwnbgmxTiqf67DtDkssIfGteFEjTPUk1pbUJlPD_sriMD-BTetkffyK8L1U4ObRNxc6x0HpdxTzwgsEwpuqwmmngN_F6Vz9QJpMNgvuMaJcUqGWOPso0jYD0t54epoqNb7LHD5o165vi-gxiUwHO_GYsF7NGrNFakqWrJcDlYBtGGdq5XhsVpNJ7gjApJvndJ5JL9kfquS4wa2YNWqslmwGHjkpIre-o8npG4dJ0WaiCtCFAIlGCbNg0JUBVul3jLSTfEiyVE7iv7ExHr0NORWea_ITSeAa9d959_sb8kuL0lllun04hv3a-a-B1cg27BzW46eHV-7z5BzfO-4qjav3N9ksaUk1ymevF0IvyTz82Wc-fsra8fXVAsOOqqTMiaj36CFahNqvZL_E0mMFzOLYtGfH_XzsGbU_2oHKpQnGgn4aJsJWcgJYJNwGZErHuqw"
    formData.append("g-recaptcha-response", data.captcha);
    formData.append("inf_form_xid", "59b15b0208bf6b692ee1c503691f71fd");
    formData.append("inf_form_name", "Tienda Virtual Form");
    formData.append("infusionsoft_version", "1.70.0.369835");
    formData.append("inf_custom_UTMMedium", "");
    formData.append("inf_custom_UTMCampaign", "");
    formData.append("inf_custom_Source", "");
    formData.append("inf_custom_GCLID", "");
    formData.append("inf_field_FirstName", "A");
    formData.append("inf_field_Email", "a@a.com");
    formData.append("inf_field_Phone1", "112312312");
    formData.append("inf_field_Country", "Argentina");
    formData.append("inf_custom_Franquicias", "TOLUCA");
    formData.append("inf_custom_Producto1", "Placas Anti humedad");
    formData.append("inf_custom_SucursalesColombia1", "C.C. Mall Laureles");
    formData.append("inf_custom_ProductosColombia1", "Pisos Flotantes");
    formData.append("inf_custom_SucursalesUruguay", "Maldonado");
    formData.append("inf_custom_ProductosUruguay", "Revestimientos");
    formData.append("inf_custom_SucursalesBolivia1", "Sin Sucursal");
    formData.append("inf_custom_ProductosBolivia", "Revestimientos");
    formData.append("inf_custom_SucursalesParaguay", "Asuncion");
    formData.append("inf_custom_ProductosParaguay", "Pisos Rusticos");
    formData.append("inf_custom_SucursalesEcuador", "Quito");
    formData.append("inf_custom_ProductosEcuador1", "Revestimientos");
    formData.append("inf_custom_SucursalesMexico", "Toluca");
    formData.append("inf_custom_ProductosMexico", "Franquicias");
    formData.append("inf_custom_SucursalesGuatemala", "Guatemala");
    formData.append("inf_custom_ProductosGUA", "Franquicias");
    formData.append("inf_custom_SucursalesCR", "San Jose");
    formData.append("inf_custom_ProductosCR", "Franquicias");
    formData.append("inf_custom_Consulta", "Consulta");

    // this.loadingService.setShowLoading(true);
    this.contactService.sendEmail(formData).subscribe(
      (response) => {
        console.log(response);
        // this.messagesService.setShowMessages(true, 'success', 'Thank you for your message. We’ll reply as soon as possible!');
        this.clearForm();
        // this.loadingService.setShowLoading(false);
      },
      (error) => {
        console.log(error);
        // this.messagesService.setShowMessages(true, 'danger', 'There was an error sending your message. Try again in a few minutes.');
        // this.loadingService.setShowLoading(false);
      }
    );
  }

  @HostListener("window:beforeunload", ["$event"])
  unloadHandler(event: Event) {
    console.log(event);
    // event.preventDefault();
    // event.returnValue = false;
    delete event["returnValue"];
  }
}
